import styled from 'styled-components';

const Wrapper = styled.div`
	position: relative;
	top: -67px;
	background-color: #f6f6f6;
	height: Calc(100vh - 40px);
	.preview-header {
		background-color: #fff;
		position: relative;
		padding-left: 150px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.exchange-image {
			width: 100px;
			position: absolute;
			left: 30px;
			top: 10px;
		}
		h2 {
			line-height: 1.5;
			font-size: 44px;
			font-weight: bold;
			padding: 25px 0;
			margin-bottom: 0;
			box-sizing: border-box;
		}
		.preview-header-btn-wrapper {
			margin-right: 50px;
			> * {
				margin-right: 25px;
			}
		}
	}
	.preview-body {
		padding: 24px 62px;
		position: relative;
		.pc-img {
			position: absolute;
			right: 62px;
			top: 62px;
			width: 30%;
			min-width: 300px;
			text-align: center;
			img {
				width: 100%;
			}
		}
		.url {
			color: #808083;
			margin-bottom: 34px;
			.url-domain {
				display: inline-block;
				font-size: 26px;
				line-height: 41px;
				width: auto;
				padding-right: 23px;
				/* border-right: 1px solid #6d6e71; */
			}
		}
		.preview-body-card {
			margin-bottom: 22px;
			h3 {
				font-size: 18px;
				font-weight: bold;
			}
			.pair-card {
				margin-bottom: 8px;
				.versus {
					line-height: 74px;
					font-size: 22px;
					padding: 0 12px;
				}
				.coin-wrap {
					display: inline-block;
					.coin-ico {
						width: 74px;
						height: 74px;
						line-height: 74px;
						border-radius: 37px;
						font-size: 22px !important;
					}
				}
			}
		}
	}
`;

export default Wrapper;
